import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { IRespFichaClinica } from '../../interfaces/ficha-clinica.interface';

@Injectable({
  providedIn: 'root',
})
export class FichaClinicaService {
  private readonly clientId = '4b9b9ab5b734408d915ec31751bbf114';

  private readonly httpClient = inject(HttpClient);

  info(idAgendamiento: string): Observable<IRespFichaClinica> {
    const params = new HttpParams().set('client-id', this.clientId);

    return this.httpClient.get<IRespFichaClinica>(
      `${environment.baseURL}ficha-clinica/status/${idAgendamiento}`,
      {
        params,
      }
    );
  }

  finish(idAgendamiento: string): Observable<IRespFichaClinica> {
    const params = new HttpParams().set('client-id', this.clientId);

    return this.httpClient.get<IRespFichaClinica>(
      `${environment.baseURL}ficha-clinica/finish/${idAgendamiento}`,
      {
        params,
      }
    );
  }
}
